import { AxiosError, AxiosResponse } from 'axios';
import ContactDto from 'common/dto-types/contacts/contact-dto';
import CityDto from 'common/dto-types/city-dto';
import ListWithTotal from 'common/dto-types/list-with-total-dto';
import axiosServices, { buildQueryParams, PaginationAndFiltersParams } from 'utils/axios';
import { GET_HOST_CITIES } from 'pages/calendar/api';

const CONTACT_API_URL = 'contacts';

export const fetchContactList = async (
    params: PaginationAndFiltersParams,
): Promise<ListWithTotal<ContactDto> | null | undefined> => {
    try {
        const res = await axiosServices.get(`${CONTACT_API_URL}${buildQueryParams(params)}`);
        return res.data;
    } catch (err) {
        // TODO: Implement a proper way to handle errors
        // https://fifadigital.atlassian.net/browse/FMH-2075
        console.error(err);
        return null;
    }
};

export const createContact = async (contact: any): Promise<ContactDto | null | undefined> => {
    try {
        return await axiosServices.post(CONTACT_API_URL, contact).then((res) => res.data);
    } catch (err) {
        console.error(err);
        return null;
    }
};

export const updateContact = async (contact: any): Promise<ContactDto | null | undefined> => {
    try {
        return await axiosServices.put(CONTACT_API_URL, contact).then((res) => res.data);
    } catch (err) {
        console.error(err);
        return null;
    }
};

export const getContactById = async (id: number): Promise<ContactDto | null | undefined> => {
    try {
        return await axiosServices.get(`${CONTACT_API_URL}/${id}`).then((res) => res.data);
    } catch (err) {
        console.error(err);
        return null;
    }
};

export const deleteContactById = async (id: number): Promise<number | null> => {
    try {
        return await axiosServices.delete(`${CONTACT_API_URL}/${id}`).then((res) => res.status);
    } catch (err) {
        console.error(err);
        return null;
    }
};

export const importAssociationsAndConfederations = async (): Promise<AxiosResponse | null | undefined> => {
    try {
        return await axiosServices.post(`${CONTACT_API_URL}/importAssociationsAndConfederations`);
    } catch (err) {
        const axiosError = err as AxiosError;
        return axiosError.response || null;
    }
};

export const getCities = async (): Promise<CityDto[]> => {
    try {
        const res = await axiosServices.get(`/${GET_HOST_CITIES}`);
        return res.data;
    } catch (err) {
        console.error(err);
        return [];
    }
};
